import { matchPath, useLocation } from "react-router-dom";
import { pagesNoBack } from "@View/components/headers/Crumbs";

export const useBackButton = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  return !pagesNoBack.some((page) =>
    matchPath(currentPath, { path: page, exact: true })
  );
};
